const wrongWordsMap = new Map();
wrongWordsMap.set("lion", 3);
wrongWordsMap.set("forest", 3);
wrongWordsMap.set("car", 2);
wrongWordsMap.set("desk", 1);
wrongWordsMap.set("computer", 1);
export const UserData = [
    {
        id: "Peppa Pig",
        session: 1,
        accuracy: 70,
        cwpm: 30,
        correctWords: 10,
        wrongWords: 5,
        correctWordsPercentage: 95,
        incorrectWordsPercentage: 5,
        partialWordsPercentage: 0,
        passageScore: 80,
        userScore: 60,
        wrongWordsMap: wrongWordsMap,
    },
    {
        id: "The Cat and the Hat",
        session: 2,
        accuracy: 75,
        cwpm: 32,
        correctWords: 6,
        wrongWords: 7,
        correctWordsPercentage: 95,
        incorrectWordsPercentage: 5,
        partialWordsPercentage: 0,
        passageScore: 80,
        userScore: 60,
        wrongWordsMap: wrongWordsMap,
    },
    {
        id: "If You Give a Mouse a Cookie",
        session: 3,
        accuracy: 80,
        cwpm: 40,
        correctWords: 19,
        wrongWords: 2,
        correctWordsPercentage: 78,
        incorrectWordsPercentage: 10,
        partialWordsPercentage: 12,
        passageScore: 80,
        userScore: 60,
        wrongWordsMap: wrongWordsMap,
    },
    {
        id: "Finding Nemo",
        session: 4,
        accuracy: 90,
        cwpm: 18,
        correctWords: 16,
        wrongWords: 0,
        correctWordsPercentage: 95,
        incorrectWordsPercentage: 5,
        partialWordsPercentage: 0,
        passageScore: 80,
        userScore: 60,
        wrongWordsMap: wrongWordsMap,
    },
    {
        id: "The Cat and the Hat",
        session: 5,
        accuracy: 100,
        cwpm: 29,
        correctWords: 23,
        wrongWords: 1,
        correctWordsPercentage: 95,
        incorrectWordsPercentage: 5,
        partialWordsPercentage: 0,
        passageScore: 80,
        userScore: 60,
        wrongWordsMap: wrongWordsMap,
    },
    {
        id: "Peppa Pig",
        session: 6,
        accuracy: 100,
        cwpm: 42,
        correctWords: 19,
        wrongWords: 3,
        correctWordsPercentage: 95,
        incorrectWordsPercentage: 5,
        partialWordsPercentage: 0,
        passageScore: 80,
        userScore: 60,
        wrongWordsMap: wrongWordsMap,
    }
]